var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeopleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    stroke: "black",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.8385C1 11.0052 2.5 9.50517 4.33333 9.50517H7.66667C9.5 9.50517 11 11.0052 11 12.8385M12.6667 8.67184H15.1667C16.5833 8.67184 17.6667 9.75517 17.6667 11.1718M8.08333 2.00517C9.25 3.17184 9.25 5.00517 8.08333 6.08851C6.91667 7.17184 5.08333 7.25517 4 6.08851C2.91667 4.92184 2.83333 3.17184 3.91667 2.00517C5 0.838505 6.91667 0.921839 8.08333 2.00517ZM15.4167 2.58851C16.25 3.42184 16.25 4.75517 15.4167 5.50517C14.5833 6.25517 13.25 6.33851 12.5 5.50517C11.75 4.67184 11.6667 3.33851 12.5 2.58851C13.25 1.83851 14.5833 1.83851 15.4167 2.58851Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/people-icon.ba88a2e180d68edb3cdc2df9868a412a.svg";
export { ForwardRef as ReactComponent };